"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickClaim = exports.getOffersBy = exports.switchToPersona = exports.getTestnetPersonas = exports.logVelocityEvent = exports.getShareDisclosure = exports.getVerificationResultPdf = exports.verifyDisclosure = exports.getDetails = exports.verifyContactDetail = exports.createContactDetail = exports.deleteDisclosure = exports.editDisclosure = exports.getDisclosureById = exports.getDisclosures = exports.deleteCredential = exports.createDisclosure = exports.claimOffersFromDeeplink = exports.claimOffers = exports.getOffers = exports.getCredentialManifest = exports.getCredentials = exports.getIssuers = void 0;
const axios_1 = __importDefault(require("axios"));
const storageUtils_1 = require("../utils/storageUtils");
const constants_1 = require("../../constants/constants");
const getIssuers = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.getIssuers(), {});
        var responseJson = response.data;
        if (response.status !== 200)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
exports.getIssuers = getIssuers;
const getCredentials = (isLoggedInUserProfile = true, username) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (!isLoggedInUserProfile) {
            delete axios_1.default.defaults.headers.common["Authorization"];
        }
        let response = yield axios_1.default.post(constants_1.VclRoutes.getCredentials(), {
            username,
        });
        if (!isLoggedInUserProfile) {
            axios_1.default.defaults.headers.common["Authorization"] = (0, storageUtils_1.getToken)();
        }
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        const { success: _ } = responseJson, credentials = __rest(responseJson, ["success"]);
        return credentials;
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
exports.getCredentials = getCredentials;
const getCredentialManifest = (issuer) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.getCredentialManifest(), Object.assign({}, issuer));
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log(err);
        return err.response.data;
    }
});
exports.getCredentialManifest = getCredentialManifest;
const getOffers = (velocityCredentialIds, manifestJwt) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.discloseIdentityCredentials(), {
            velocityCredentialIds,
            manifestJwt,
        });
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log(err);
        return err.response.data;
    }
});
exports.getOffers = getOffers;
const claimOffers = (approvedOfferIds, manifestJwt, offerToken) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.claimOffers(), {
            approvedOfferIds,
            rejectedOfferIds: [],
            manifestJwt,
            offerToken,
        });
        var responseJson = response.data;
        if (response.status !== 200)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log(err);
        return err.response.data.errorCode;
    }
});
exports.claimOffers = claimOffers;
const claimOffersFromDeeplink = (approvedOfferIds, offerToken) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.claimOffersFromDeeplink(), {
            approvedOfferIds,
            rejectedOfferIds: [],
            offerToken,
        });
        var responseJson = response.data;
        if (response.status !== 200)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log(err);
        return err.response.data.errorCode;
    }
});
exports.claimOffersFromDeeplink = claimOffersFromDeeplink;
const createDisclosure = (title, durationNumber, durationType, credentials) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.createDisclosure(), {
            selectedCredentialsToDisclose: credentials,
            title,
            durationType,
            durationNumber,
        });
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson.id;
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
exports.createDisclosure = createDisclosure;
const deleteCredential = (credentialId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.delete(constants_1.VclRoutes.deleteCredential(), {
            data: {
                credentialIdentifier: credentialId,
            },
        });
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson.message;
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
exports.deleteCredential = deleteCredential;
const getDisclosures = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.get(constants_1.VclRoutes.getDisclosures());
        const disclosures = response.data.disclosures;
        disclosures.map((disc) => (Object.assign(Object.assign({}, disc), { validUntil: new Date(disc.validUntil) })));
        return disclosures;
    }
    catch (err) {
        console.log("err", err);
        return [];
    }
});
exports.getDisclosures = getDisclosures;
const getDisclosureById = (disclosureId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.getDisclosureById(), {
            disclosureIdentifier: +disclosureId,
        });
        const disclosure = response.data;
        return disclosure;
    }
    catch (err) {
        console.log("err", err);
        return null;
    }
});
exports.getDisclosureById = getDisclosureById;
const editDisclosure = (disclosureId, title, durationNumber, durationType) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.editDisclosure(), {
            disclosureId: +disclosureId,
            title,
            extendDurationType: durationType,
            extendDurationNumber: durationNumber,
        });
        const disclosure = response.data;
        return disclosure;
    }
    catch (err) {
        console.log("err", err);
        return { success: false };
    }
});
exports.editDisclosure = editDisclosure;
const deleteDisclosure = (disclosureId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.delete(constants_1.VclRoutes.deleteDisclosure(), {
            data: {
                id: disclosureId,
            },
        });
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson.error || responseJson.message;
    }
    catch (err) {
        console.log(err);
        return null;
    }
});
exports.deleteDisclosure = deleteDisclosure;
const createContactDetail = (type, value, recaptchaToken) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.createContactDetail(), {
            type,
            value,
            reCaptchaToken: recaptchaToken,
        });
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        return err.response.data;
    }
});
exports.createContactDetail = createContactDetail;
const verifyContactDetail = (id, code) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.verifyContactDetail(), {
            id,
            code,
        });
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        return err.response.data;
    }
});
exports.verifyContactDetail = verifyContactDetail;
const getDetails = (credentialId, credentialType, disclosureId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const body = disclosureId
            ? { id: credentialId, credentialType, disclosureId }
            : { id: credentialId, credentialType };
        let response = yield axios_1.default.post(constants_1.VclRoutes.getDetails(), body);
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log("err", err);
        return null;
    }
});
exports.getDetails = getDetails;
const verifyDisclosure = (disclosureId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield axios_1.default.post(constants_1.VclRoutes.verifyDisclosure(), {
            disclosureId,
        });
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log("err", err);
        return null;
    }
});
exports.verifyDisclosure = verifyDisclosure;
const getVerificationResultPdf = (verificationLogId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let customizedUrl = constants_1.VclRoutes.verificationResultPdf + "/" + verificationLogId;
        yield axios_1.default.get(customizedUrl, { responseType: "blob" }).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `disclosure_${verificationLogId}.pdf`);
            document.body.appendChild(link);
            link.click();
        });
    }
    catch (err) {
        console.log("err", err);
        return null;
    }
});
exports.getVerificationResultPdf = getVerificationResultPdf;
const getShareDisclosure = (credentialId, credentialTitle, type) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield axios_1.default.post(constants_1.VclRoutes.getShareDisclosure(), {
            credentialId,
            credentialTitle,
            type,
        });
        let responseJson = res.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson.disclosure;
    }
    catch (err) {
        console.log("err", err);
        return null;
    }
});
exports.getShareDisclosure = getShareDisclosure;
const logVelocityEvent = (type, entityId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield axios_1.default.post(constants_1.VclRoutes.createActivityVelocityLog(), {
            type,
            entityId,
        });
        let responseJson = res.data;
        if (!responseJson.success)
            throw new Error();
    }
    catch (err) {
        console.log("err", err);
    }
});
exports.logVelocityEvent = logVelocityEvent;
const getTestnetPersonas = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield axios_1.default.get(constants_1.VclRoutes.getTestnetPersonas());
        return res.data.data;
    }
    catch (err) {
        console.log(err);
        return [];
    }
});
exports.getTestnetPersonas = getTestnetPersonas;
const switchToPersona = (persona) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield axios_1.default.post(constants_1.VclRoutes.switchToPersona(), { persona });
    return res.data;
});
exports.switchToPersona = switchToPersona;
const getOffersBy = (query) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield axios_1.default.post(constants_1.VclRoutes.getOffersBy(), query);
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log(err);
        return err.response.data;
    }
});
exports.getOffersBy = getOffersBy;
const quickClaim = (query) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield axios_1.default.post(constants_1.VclRoutes.quickClaim(), query, {
            headers: {
                Authorization: (0, storageUtils_1.getToken)(),
            },
        });
        let responseJson = response.data;
        if (!responseJson.success)
            throw new Error();
        return responseJson;
    }
    catch (err) {
        console.log(err);
        return err.response.data;
    }
});
exports.quickClaim = quickClaim;
